<template>
    <div class="FilePreview">
        <span class="FilePreview__display">
            <BlobImage
                v-if="isImage"
                class="FilePreview__image"
                :src="file"
            />
            <Icon v-else name="file" />
        </span>
        <span class="FilePreview__fileName" data-wg-notranslate>
            {{ fileName }}
            <div v-if="uploading" class="IndefiniteProgressBar" />
        </span>
        <span v-if="!uploading" class="FilePreview__removeIcon" touch-action="auto" @click="removeFile">
            <Icon name="delete" />
        </span>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    import BlobImage from '@/components/common/BlobImage.vue';
    import Icon from '@/components/common/Icon.vue';

    @Component({
        emits: [ 'remove' ],
        components: { BlobImage, Icon },
    })
    export default class FilePreview extends Vue {
        // PRODUCT-26110 Phase 2B2 Task 5 batch 4: the fork's bare-constructor-shorthand
        // `@Prop(ctor)` overload only types String/Number/Boolean/Object/Array/
        // Function/Symbol constructors (`PropConstructorShorthand`, vue-property-
        // decorator/index.d.ts) -- an arbitrary class constructor like the DOM `File`
        // type was never part of that shorthand union, in Vue 2 or in this fork.
        // vue-facing-decorator's real `PropsConfig.type` is untyped (`any`), so the
        // object-config form accepts it with no runtime behavior change (the shim
        // normalizes bare constructors into this exact `{ type }` shape anyway).
        @Prop({ type: File })
        private file!: File;

        @Prop({ type: Boolean, default: false })
        private uploading!: boolean;

        private get fileName() {
            return this.file?.name || '<unknown>';
        }

        private get isImage() {
            return Boolean(this.file?.type) && this.file.type.indexOf('image') === 0;
        }

        private removeFile() {
            this.$emit('remove', this.file);
        }
    }
</script>
